import React from "react";
import { Grid, Typography, Divider, Select, MenuItem } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

import Image from "./Image";
import { ModelParameters } from "../redux/App.store";
import ModelParametersTable from "./ModelParametersTable";

const ModelsView = () => {
  const basenames = useSelector((state: RootState) => state.app.basenames);
  const models = useSelector((state: RootState) => state.app.models);
  const models_data = useSelector(
    (state: RootState) => state.app.current_models_parameters
  );

  const [currentModel, setCurrModel] = React.useState("RRB");
  const [cur_svg, setCurrSVG] = React.useState<string>(
    models.length > 0 ? models[0].data : ""
  );

  const [currentModelData, setCurrModelData] = React.useState<ModelParameters>({
    model_repr: "",
    key: "",
    parameters: [],
    r_squared: 0,
    error_mean: 0,
  });

  // functions
  const updateModelData = () => {
    const model = models_data.find((el) => el.key === currentModel);
    if (model) {
      setCurrModelData(model);
    }
  };

  React.useEffect(updateModelData, [currentModel, models_data]);

  const handleModelChange = (e: any) => {
    const m = e.target.value;
    setCurrModel(m);
    const s = models.filter((model) => {
      return model.key === m;
    });
    setCurrSVG(s[0].data);
  };

  return (
    <Grid container item>
      <Grid
        item
        container
        xs={12}
        justify="center"
        style={{ marginBottom: "20px" }}
      >
        <Grid item>
          <Typography variant="h6">{basenames[0] + ".xps"} </Typography>
        </Grid>
      </Grid>

      <Grid container item xs={12}>
        <Grid
          container
          item
          alignItems="flex-end"
          style={{ marginBottom: "15px" }}
        >
          <Grid item xs={4}>
            <Typography variant="h6">Modelo: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Select value={currentModel} onChange={handleModelChange}>
              <MenuItem value="RRB">RRB</MenuItem>
              <MenuItem value="Log-normal">Log-normal</MenuItem>
              <MenuItem value="Sigmoid">Sigmoid</MenuItem>
              <MenuItem value="GGS">GGS</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item container xs={12} justify="center">
          <Grid item style={{ marginBottom: "20px" }}>
            <Typography variant="h6" style={{ marginTop: 20 }}>
              Curva ajustada - erro médio:{" "}
              {currentModelData.error_mean.toFixed(5)}; r-quadrado:{" "}
              {currentModelData.r_squared.toFixed(5)}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Image svgB64={cur_svg} />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid
          item
          container
          xs={12}
          justify="center"
          spacing={1}
          style={{ marginTop: "20px" }}
        >
          <Grid item container xs={12} justify="center">
            <Grid item>
              <Typography variant="h6">Equação:</Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} justify="center">
            <Grid item>
              <Typography variant="h6">
                {currentModelData.model_repr}
              </Typography>
            </Grid>
          </Grid>
          <Grid item style={{ marginTop: "20px" }}>
            <ModelParametersTable parameters={currentModelData.parameters} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModelsView;
